export class FloatNumber {
  private value?: number;
  private constructor(value?: number) {
    this.value = value;
  }

  static fromNumber(value?: number) {
    return new FloatNumber(value);
  }

  round(precision: number) {
    return Number(this.value?.toFixed(precision));
  }
}
